// extracted by mini-css-extract-plugin
module.exports = {"user-feed":"home_user-feed__2Tx6J"};